export default __webpack_public_path__ + "static/Metropolis-ExtraLightItalic-82cf4b28b2c3b0cfbff9c28b6a8ea89b.woff2";